module.exports = __webpack_public_path__ + "static/img/10018 (1).4dd80c6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10018 (1).webp
// module id = 77Cu
// module chunks = 14